import objectOfGetParamsFromUrl from "../../../../scripts/helpers/object.of.get.params.from.url";
import { useGet } from "../../../../scripts/backend/hooks";
import objectToGetParams from "../../../../scripts/helpers/object.to.get.params";
import Carcas from "../../../components/containers/carcas";
import StatsList from "../../../components/ui/stats.list";


const UsersStats = () => {
  

  return (

    <Carcas>

      <StatsList />

    </Carcas>
    
  );

}

export default UsersStats;
